<template>
  <div class="panoramic" v-show="panoramicShow">
    <div id="container">
      <img src="@/assets/image/zoom.png" @click="shrink" v-show="!enlargeShow">
      <img src="@/assets/image/zoom-open.png" @click="enlargeModel" v-show="enlargeShow">
    </div>
    <div id="container2">
      <img src="@/assets/image/zoom.png" @click="shrink" v-show="!enlargeShow">
      <img src="@/assets/image/zoom-open.png" @click="enlargeView" v-show="enlargeShow">
    </div>
    <panoramicInfo v-if="['live', 'navigation'].includes(source)"
                   ref="panoramicInfo"
                   :handle-pid="handlePid"
                   :panoramasData="panoramasData"
                   @changeX="changeX"
                   @changeY="changeY"
                   @changeZ="changeZ"
                   @saveAdjust="saveAdjust"
                   @resetSlider="resetSlider"/>

  </div>
</template>

<script>
import {
  Stage,
  FloorModel,
  PerspectiveView,
  OrthographicView,
  AerialElementController,
  THREE,
  EventHub,
  Events,
  PanoramaGroup,
  PanoramaController,
  AlignmentUtils,
  IndicatorDisplayMode,
} from '@aibee/owlly';
import { listPanoramas, adjustPanorama, getListPanoAdjus, modifyPanorama } from '@/api/map';
import panoramicInfo from '@/components/mapComponents/panoramicInfo.vue';

export default {
  name: 'panoramic',
  components: { panoramicInfo },
  computed: {
    source() {
      return this.$route.params.source;
    },
    task_type() {
      return this.source === 'navigation' ? 3 : 1;
    },
  },
  props: {
    panoramaImages: {
      type: Array,
    },
    isHiddenMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stage: null,
      panoramaController: null,
      panoramaGroup: null,
      panorama: null,
      list: [],
      model_path: '',
      initial_view: {},
      handlePid: 0,
      handleSeqId: 0,
      enlargeShow: true,
      sliderFlag: false,
      panoramicShow: true,
      direction: [],
      x: 0,
      y: 0,
      z: 0,
      panoramasData: null,
    };
  },
  mounted() {
    if (this.$route.query.floor_id) this.getListPanoramas();
  },
  watch: {
    list: {
      handler(val) {
        this.init();
      },
    },
    panoramaImages: {
      handler(val) {
        this.panorama.updateTexture(val);
      },
      deep: true,
    },
  },
  methods: {
    getListPanoramas() {
      // 测试本地 floor_id:YYMI2Y7lqaECCx3F    线上ZvS3rR6u02LBa334
      if (!this.$route.query.vr_id) {
        return this.$message.warning('获取全景数据需要先在对应的楼层填写vr_id');
      }
      listPanoramas(this.$route.query.vr_id).then((res) => {
      // listPanoramas('ZvS3rR6u02LBa334', { task_type: 1 }).then((res) => {
        if (!res.data.data.panorama_list) { this.panoramicShow = false; return; }
        this.list = res.data.data.panorama_list;
        this.model_path = res.data.data.model_path;
        this.initial_view = res.data.data.initial_view;
        this.panoramasData = res.data.data;
      }).catch(() => {
        this.$message.error('获取全景数据出错');
      })
    },
    async init() {
      this.stage = new Stage(); // 初始化场景
      const container = document.getElementById('container');
      const container2 = document.getElementById('container2');
      // 测试用
      // this.stage.setStatsEnabled(true); // 开启帧率统计显示
      // this.stage.setAxesEnabled(true); // 开启坐标轴显示
      // 楼层模型
      const model = new FloorModel(this.model_path);
      this.stage.bindElement(model); // 绑定一下, 几乎所有东西都要绑定一次到stage
      if (container && container2) {
        const view = new OrthographicView(container); // 俯视视图, 平行投影
        const view2 = new PerspectiveView(container2); // 全景视图, 正常投影
        // 初始化一个有一个全景图的全景图组
        this.panoramaGroup = new PanoramaGroup(this.list.map(p => ({
          // pid: p.id,
          pid: p.seq_id,
          textureURLs: p.panorama_images_low,
          neighbourPanoramaIDs: p.visible_panorama_seq_ids,
          position: new THREE.Vector3(p.coordinate.position_x, p.coordinate.position_y, p.coordinate.position_z),
          quaternion: new THREE.Quaternion(p.coordinate.direction_x, p.coordinate.direction_y, p.coordinate.direction_z, p.coordinate.direction_w),
        })), {
          modelElement: model,
          visibleRadius: 1000,
        }, true);
        this.list.forEach((item) => {
          if (!item.visible) {
            this.panoramaGroup.setIndicatorVisibility(item.visible, item.seq_id);
          }
        });
        // 全景图控制器, 可以用鼠标在全景图视图里面用鼠标转
        this.panoramaController = new PanoramaController(view2, this.panoramaGroup, model);
        // stage各种绑定一下
        this.stage.bindView(view);
        this.stage.bindView(view2);
        this.stage.bindElement(this.panoramaGroup);
        this.stage.bindController(this.panoramaController);
        // 切换点位
        this.panoramaController.setMouseClickEnabled(true);
        // 注册前清除事件
        try {
          EventHub.remove(Events.PANORAMA_SELECTED, this.onPanoSelect);
          EventHub.remove(Events.CLICK_PANORAMA, this.onPanoClick);
        } catch (error) {}

        // 注册事件, 返回全景点位id
        EventHub.on(Events.PANORAMA_SELECTED, this.onPanoSelect);
        EventHub.on(Events.CLICK_PANORAMA, this.onPanoClick);

        const controller = new AerialElementController(view); // 俯视图的控制器
        controller.setElementMovable(false);

        const panoramas = await this.panoramaGroup.getAllPanoramas();
        console.info('## panoramas=', panoramas);
        this.panoramaGroup.addViewConfiguration({
          targetView: view,
          showBorder: true,
          showSkyBox: false,
        });
        this.panoramaGroup.addGroupViewConfiguration({
          targetView: view,
          indicatorDisplayMode: IndicatorDisplayMode.Editing,
          showIndicators: true,
        });
        this.panoramaGroup.addGroupViewConfiguration({
          targetView: view2,
          indicatorDisplayMode: IndicatorDisplayMode.Editing,
          showIndicators: true,
        });
        controller.bindElement(panoramas);
        this.handlePid = this.list[0].id;
        this.handleSeqId = this.list[0].seq_id;
        this.direction = [this.list[0].coordinate.direction_x, this.list[0].coordinate.direction_y, this.list[0].coordinate.direction_z, this.list[0].coordinate.direction_w];
        this.panorama = await this.panoramaGroup.getPanoramaByPID(this.handleSeqId); // 拿一个全景图
        // 调用一次渲染全景图
        this.panoramaController.lookFromPanorama(this.handleSeqId, new THREE.Vector3(
          this.initial_view.roaming_direction_x,
          this.initial_view.roaming_direction_y,
          this.initial_view.roaming_direction_z,
        ));
        this.onPanoSelect(this.handleSeqId);
        // 调整矫正时设置全景图的旋转
        // this.panorama.setAdditionalRotationInEuler(0, Math.PI / 18, 0); // 返回 Quaternion {x: 0, y: 0.08715574274765817, z: 0, w: 0.9961946980917455}
        // // 初始化时设置全景图的旋转
        // this.panorama.setAdditionalRotationInQuaternion(0, 0.08715574274765817, 0, 0.9961946980917455); // 返回 Euler {x: -0, y: 0.17453292519943295 === Math.PI / 18, z: -0}
        // const euler = this.panorama.setAdditionalRotationInQuaternion(...this.direction);
        // controller.bindElement(this.panorama); // 全景图绑定到AerialElementController
        this.stage.bindController(controller); // 将AerialElementController绑定到stage
        // console.log(this.panorama.setAdditionalRotationInEuler(0, Math.PI / 18, 0));
        // console.log(this.panorama.setAdditionalRotationInQuaternion(0, 0.08715574274765817, 0, 0.9961946980917455));
        this.stage.forceResize();
        // 弧度转角度
        // this.x = euler.x * (180 / Math.PI);
        // this.y = euler.y * (180 / Math.PI);
        // this.z = euler.z * (180 / Math.PI);
      }
    },
    async onPanoSelect(pid) {
      console.log(
        'onPanoSelect panorama selected',
        pid,
      );
      this.$children[0].x = 0;
      this.$children[0].y = 0;
      this.$children[0].z = 0;
      this.handleSeqId = pid;
      this.handlePid = this.list.find(item => item.seq_id === pid).id;
      const idx = this.list.findIndex(item => item.seq_id === pid);
      this.direction = [this.list[idx].coordinate.direction_x, this.list[idx].coordinate.direction_y, this.list[idx].coordinate.direction_z, this.list[idx].coordinate.direction_w];
      this.panorama = await this.panoramaGroup.getPanoramaByPID(this.handleSeqId); // 拿一个全景图
      getListPanoAdjus(this.$route.query.floor_id, { task_type: this.task_type }).then((res) => {
        const adjustmentInfo = res.data.data.adjustment_info;
        if (Object.keys(adjustmentInfo).includes(this.handlePid.toString())) {
          this.$children[0].x = adjustmentInfo[this.handlePid].offset_x;
          this.$children[0].y = adjustmentInfo[this.handlePid].offset_y;
          this.$children[0].z = adjustmentInfo[this.handlePid].offset_z;
          this.panorama.setAdditionalRotationInEuler(
            // 角度转弧度
            adjustmentInfo[this.handlePid].offset_x * (Math.PI / 180),
            adjustmentInfo[this.handlePid].offset_y * (Math.PI / 180),
            adjustmentInfo[this.handlePid].offset_z * (Math.PI / 180),
          );
        }
        this.panoramaController.moveToPanorama(this.handleSeqId, { fadeInOut: true });
      });
      this.panoramaController.setMouseClickEnabled(true);
    },
    async onPanoClick(pid, event) {
      console.log(
        'onPanoClick panorama selected',
        pid,
      );
      this.$children[0].x = 0;
      this.$children[0].y = 0;
      this.$children[0].z = 0;
      this.handleSeqId = pid;
      this.handlePano = this.list.find(item => item.seq_id === pid);
      this.handlePid = this.handlePano.id;
      if (event.button === 0) {
        const idx = this.list.findIndex(item => item.seq_id === pid);
        this.direction = [this.list[idx].coordinate.direction_x, this.list[idx].coordinate.direction_y, this.list[idx].coordinate.direction_z, this.list[idx].coordinate.direction_w];
        this.panorama = await this.panoramaGroup.getPanoramaByPID(this.handleSeqId); // 拿一个全景图
        getListPanoAdjus(this.$route.query.floor_id, { task_type: this.task_type }).then((res) => {
          const adjustmentInfo = res.data.data.adjustment_info;
          if (Object.keys(adjustmentInfo).includes(this.handlePid.toString())) {
            this.$children[0].x = adjustmentInfo[this.handlePid].offset_x;
            this.$children[0].y = adjustmentInfo[this.handlePid].offset_y;
            this.$children[0].z = adjustmentInfo[this.handlePid].offset_z;
            this.panorama.setAdditionalRotationInEuler(
              adjustmentInfo[this.handlePid].offset_x * (Math.PI / 180),
              adjustmentInfo[this.handlePid].offset_y * (Math.PI / 180),
              adjustmentInfo[this.handlePid].offset_z * (Math.PI / 180),
            );
          }
        });
        this.panoramaController.setMouseClickEnabled(true);
      } else if (event.button === 2 && this.isHiddenMode) {
        // 右键隐藏全景点
        modifyPanorama({ panorama_id: this.handlePid, visible: this.handlePano.visible ? 0 : 1 }).then((res) => {
          if (res.data.retcode === 200) {
            this.handlePano.visible = !this.handlePano.visible;
            this.panoramaGroup.setIndicatorVisibility(this.handlePano.visible, pid);
            if (this.handlePano.visible) this.panoramasData.visible_count += 1;
            else { this.panoramasData.visible_count -= 1; }
          }
        });
      }
    },
    changeX(val) {
      this.sliderFlag = true;
      if (val && this.sliderFlag) {
        this.panorama.setAdditionalRotationInEuler(
          val,
          this.y,
          this.z,
        );
        // this.$refs.panoramicInfo.x = val * (180 / Math.PI);
      }
    },
    changeY(val) {
      this.sliderFlag = true;
      if (val && this.sliderFlag) {
        this.panorama.setAdditionalRotationInEuler(
          this.x,
          val,
          this.z,
        );
        // this.$refs.panoramicInfo.y = val * (180 / Math.PI);
      }
    },
    changeZ(val) {
      this.sliderFlag = true;
      if (val && this.sliderFlag) {
        this.panorama.setAdditionalRotationInEuler(
          this.x,
          this.y,
          val,
        );
        // this.$refs.panoramicInfo.z = val * (180 / Math.PI);
      }
    },
    resetSlider() {
      this.panorama.setAdditionalRotationInEuler(
        0,
        0,
        0,
      );
      this.$refs.panoramicInfo.x = 0;
      this.$refs.panoramicInfo.y = 0;
      this.$refs.panoramicInfo.z = 0;
    },
    enlargeModel() {
      document.getElementById('container').style.width = '80%';
      document.getElementById('container2').style.width = '0';
      this.stage.forceResize();
      this.enlargeShow = false;
    },
    enlargeView() {
      document.getElementById('container2').style.width = '80%';
      document.getElementById('container').style.width = '0';
      this.stage.forceResize();
      this.enlargeShow = false;
    },
    shrink() {
      document.getElementById('container2').style.width = '40%';
      document.getElementById('container').style.width = '40%';
      this.stage.forceResize();
      this.enlargeShow = true;
    },
    async saveAdjust(x, y, z) {
      const params = {
        floor_id: this.$route.query.floor_id,
        panorama_id: this.handlePid,
        offset_x: x,
        offset_y: y,
        offset_z: z,
      };
      await adjustPanorama(params);
      this.$message({
        message: '保存成功',
        type: 'success',
      });
      // const { data: { data } } = await getListPanoAdjus(this.$route.query.floor_id, { task_type: 1 });
      // this.panorama.setAdditionalRotationInEuler(
      //   Object.values(data.adjustment_info)[0].offset_x,
      //   Object.values(data.adjustment_info)[0].offset_y,
      //   Object.values(data.adjustment_info)[0].offset_z,
      // );
    },
  },
};
</script>
<style lang='less' scoped>
.panoramic{
  display: flex;
  background-color: #1b1b1b;
  height: 100%;
}
#container, #container2{
    width: 37%;
    // height: 480px;
    height: 90%;
    background-color: #fff;
    position: relative;
    border-radius: 8px;
    margin: 0 10px;
    overflow: hidden;
    img{
      position: absolute;
      right: 10px;
      top: 10px;
    }
}
</style>
